import React from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
import OriginalList from './originalList';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        columnMap: PropTypes.array,
    };

    render() {
        const { content, columnMap } = this.props;

        return (
            <Chip id="261180" type="struct" title="原创集合" groupName="正文" content={columnMap}>
                <OriginalList list={content} />
            </Chip>
        );
    }
}

export default errorBoundary(Content);
